export default function SourceTargetPagesContainer ({ source, target }) {
  return (
    <div className='pagesContainer'>
      <div className='pageName'>{source}</div>
      <div className='arrow' />
      <div className='pageName'>{target}</div>
    </div>
  )
}
